const cat_ia = {
  you: 'Tu',
  assistant: 'Cat-iA',
  send: 'Invia',
  reset: 'Nuova conversazione',
  composer_placeholder: 'Scrivi un messaggio…',
  error_generic: 'Non è stato possibile completare la risposta. Riprova.',
  error_unreachable:
    'Assistente non raggiungibile. Controlla la connessione e riprova.',
}

export default cat_ia
